module.exports = __webpack_public_path__ + "img/l.7ff289ff.jpg";